"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LUX_LOYALTY_POINTS_DEDUCTION_DATE = void 0;
/**
* @dev this is the timestamp of the points deduction applied to account orders
* placed before this date
* @returns date in ISO 8601 format
* @NOTE time in AEST is 12pm on 16th June 2025
*/
exports.LUX_LOYALTY_POINTS_DEDUCTION_DATE = '2025-06-16T02:00:00.000Z';
